module.exports = __webpack_public_path__ + "img/coin-LTC.8ed9755d.svg";